import { Button, Card, Col, Row, List } from 'antd'
import React, { useEffect, useState } from 'react'

import { recordError } from "../../../utils/logService";
import EditProjectDetail from './EditProjectDetail';
import { EnvironmentOutlined } from '@ant-design/icons';
import service from '../../../services/citizenscienceService';
import dayjs from 'dayjs';

import {
  Messages,
  Notify,
  openNotification,
  util
} from '@seims/shared';

export default function ProjectDetails({ data }) {
    let msg = "";
    const [scienceFields, setScienceFields] = useState("")
    const [scienceDomains, setScienceDomains] = useState("")
    const [initiallyCitizenScience, setInitiallyCitizenScience] = useState("No");
    const [scienceShopInitiative, setScienceShopInitiative] = useState("No");
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        loadProjectDetails();
    }, [])

    const loadProjectDetails = () => {
        if (!util.isEmpty(data)) {
            if (data.projectProfile.initiallyCitizenScience) {
                setInitiallyCitizenScience("Yes");
            } else {
                setInitiallyCitizenScience("No");
            }
            if (data.projectProfile.scienceShopInitiative) {
                setScienceShopInitiative("Yes");
            } else {
                setScienceShopInitiative("No");
            }
            let scienceFieldsList = [data.scienceFields].map((item) => `${item.value}`).join(", ");
            setScienceFields(scienceFieldsList);
            let scienceDomainsList = data.scienceDomains.map((item) => `${item.value}`).join(", ");

            // let loc = data.projectProfile.locations.map((item) => `${item?.town?.value}${', '}${item.district.value}${', '} ${item.province.value}`).join(", ");
            setScienceDomains(scienceDomainsList);
        }
    }

    const editProjectDetail = () => {
        setShowModal(true);
    }

    const handleCancel = () => {
        setShowModal(false);
    };

    const handleModalSubmit = async (values) => {
        try {
            data.projectProfile.name = values.name;
            data.projectProfile.description = values.description;
            data.projectProfile.scienceField = values.scienceField;
            data.projectProfile.scienceDomains = values.scienceDomains;
            data.projectProfile.initiallyCitizenScience = values.initiallyCitizenScience;
            data.projectProfile.startDate = dayjs(values.startDate).format("YYYY-MM-DD");
            data.projectProfile.endDate = dayjs(values.endDate).format("YYYY-MM-DD");
            data.projectProfile.locations = values.locations;
            data.projectProfile.scienceShopInitiative = values.scienceShopInitiative;
            data.projectProfile.dissemination = values.dissemination;
            data.projectProfile.otherDissemination = values.otherDissemination;
            let project = data.projectProfile;
            let projectId = data.id;
            const request = await service.editProject(
                project,
                projectId
            );

            data.address = values.address;
            if (request?.status == 200 || request?.status == 201) {
                msg = util.parseMessage(Messages.ADD_SUCCESS, "Project detail updated");
                openNotification("Project Detail", msg, Notify.SUCCESS);
            }
            setShowModal(false);
            loadProjectDetails();
        } catch (error) {
            msg = util.parseMessage(Messages.GET_FAILURE);
            openNotification("Project Detail", msg, Notify.ERROR);
            recordError(error);
        };
    };

     return (
        <div className=''>

            <Col xs={24}>
                <div className="public-portal-section">
                    <h2> Citizen Science - {data.projectProfile.name}</h2>
                </div>
            </Col>
            <Col xs={24}>
                <h3 className="center-align">Project Status - <span style={{ color: data.statusColor }}>{data.status}</span> </h3>
            </Col>
            <Card
                bordered={false}
                headStyle={{ border: 0, textAlign: "center" }}
            >
                <Row>
                    <Col xs={16}> <h3 className="h3-text">Project Details</h3></Col>
                    {(data.status !== "Rejected" && data.status !== "Closed") && (
                        <Col xs={8}>
                            <Button className="right-align-button edit-button" type="primary" shape="round" onClick={() => editProjectDetail()} >
                                Edit
                            </Button>
                        </Col>
                    )}
                </Row>
                <Row>
                    <Col xs={12} sm={8} lg={6} xxl={4}><b>Title:</b></Col>
                    <Col xs={12} md={16}>{data.projectProfile.name}</Col>
                </Row>
                <Row>
                    <Col xs={12} sm={8} lg={6} xxl={4}><b>Description:</b></Col>
                    <Col xs={12} md={16}>{data.projectProfile.description}</Col>
                </Row>
                <Row>
                    <Col xs={12} sm={8} lg={6} xxl={4}><b>Science Fields:</b></Col>
                    <Col xs={12} md={16}>{scienceFields}</Col>
                </Row>
                <Row>
                    <Col xs={12} sm={8} lg={6} xxl={4}><b>Science Domains:</b></Col>
                    <Col xs={12} md={16} >{scienceDomains}</Col>
                </Row>
                <Row>
                    <Col xs={12} sm={8} lg={6} xxl={4}><b>Planned Start Date:</b></Col>
                    <Col xs={12} md={16}>{data.projectProfile.startDate}</Col>
                </Row>
                <Row>
                    <Col xs={12} sm={8} lg={6} xxl={4}><b>Planned End Date:</b></Col>
                    <Col xs={12} md={16}>{data.projectProfile.endDate}</Col>
                </Row>
                <div className="space"></div>
                <Row>
                    <Col xs={12}><b>List of addresses:</b></Col>
                </Row>
                <List
                    itemLayout="vertical"
                    pagination={{
                        pageSize: 10,
                    }}
                    dataSource={data.address}
                    renderItem={(location) => (
                        <List.Item key={location.id} >
                            <Row>
                                <Col xs={24} md={24}>
                                    <EnvironmentOutlined style={{ color: "#2494BD", fontSize: '16px' }} />
                                     {location?.town?.value}{location?.town?.value? ', ': ''}{location.district.value}{', '}{location.province.value}
                                </Col>
                            </Row>
                        </List.Item>
                    )}
                />
                <Row>
                    <Col xs={24} md={24}><b>Was this project conceptualised as Citizen Science project from the beginning? : </b>
                        {initiallyCitizenScience}
                    </Col>
                </Row>
                <Row>
                    <Col xs={24} md={24}><b>Is the facility at this institution a Science Shop? : </b>
                        {scienceShopInitiative}
                    </Col>
                </Row>
            </Card>

            <Row>
                <Col xs={24}>
                    <EditProjectDetail
                        data={data}
                        visible={showModal}
                        onCancel={handleCancel}
                        onModalSubmit={handleModalSubmit}
                    />
                </Col>
            </Row>
        </div>
    )
}
